import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Button } from "./ui/button";
import { fmtMoney } from "../lib/format";
import { MessageCircle, Mail } from "lucide-react";

function buildMessage(client, bal, req) {
  return `Sayın ${client?.name || ""},\n\nTarafınız adına yürütülen işlemlerde kullanılmak üzere tarafımızda bulunan masraf avansı bakiyeniz ${fmtMoney(bal)} seviyesine düşmüştür.\n\nMasraf işlemlerinin kesintisiz sürdürülebilmesi amacıyla ${fmtMoney(req)} tutarında ek masraf avansının tarafımıza iletilmesini rica ederiz.\n\nSağlam Hukuk Bürosu`;
}

export function EkAvansDialog({ client, open, onClose }) {
  const tryBal = Number(client?.balances?.TRY ?? client?.try_balance ?? 0);
  const minL = Number(client?.min_advance_limit ?? 0);
  const [amount, setAmount] = useState("");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (open && client) {
      const req = Math.max(minL - tryBal, 0);
      setAmount(String(req));
      setMsg(buildMessage(client, tryBal, req));
    }
  }, [open, client]); // eslint-disable-line

  const regenerate = () => setMsg(buildMessage(client, tryBal, Number(amount || 0)));

  const phone = (client?.phone || "").replace(/[^0-9]/g, "");
  const openWhatsApp = () => window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
  const openEmail = () => window.open(`mailto:${client?.email || ""}?subject=${encodeURIComponent("Ek Masraf Avansı Talebi")}&body=${encodeURIComponent(msg)}`);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl max-h-[90vh] overflow-y-auto" data-testid="ekavans-dialog">
        <DialogHeader><DialogTitle className="font-heading text-navy-900">Ek Avans Talep Et</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="bg-slate-50 rounded-xl p-3 text-sm">
            <p className="font-medium text-navy-900">{client?.client_no} — {client?.name}</p>
            <p className="text-slate-500 font-mono text-xs mt-1">Mevcut: {fmtMoney(tryBal)} · Min: {fmtMoney(minL)}</p>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Talep Edilen Tutar (TRY)</Label>
            <div className="flex gap-2">
              <Input data-testid="ekavans-amount" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="rounded-xl" />
              <Button variant="outline" className="rounded-xl whitespace-nowrap" onClick={regenerate}>Uygula</Button>
            </div>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Mesaj Taslağı</Label>
            <Textarea data-testid="ekavans-message" value={msg} onChange={(e) => setMsg(e.target.value)} rows={8} className="rounded-xl text-sm" />
          </div>
        </div>
        <DialogFooter className="gap-2 flex-col sm:flex-row">
          <Button data-testid="ekavans-whatsapp" onClick={openWhatsApp} disabled={!phone}
            className="rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white w-full sm:w-auto">
            <MessageCircle className="w-4 h-4 mr-1" /> WhatsApp'ta Aç
          </Button>
          <Button data-testid="ekavans-email" onClick={openEmail} disabled={!client?.email}
            className="rounded-xl bg-navy-900 hover:bg-navy-800 text-white w-full sm:w-auto">
            <Mail className="w-4 h-4 mr-1" /> E-posta Taslağı
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
